// The record-mode switch for inputs the disabled fieldset cannot reach.
// A disabled <fieldset> silences native controls, but script-driven
// controls (react-aria presses run on pointer events, which still fire
// on disabled elements) keep responding — those must read this context
// and disable themselves, so every input type behaves identically when
// a screen renders as a read-only record.
import { createContext } from "react";

export const FormReadOnlyContext = createContext(false);
